import { render, staticRenderFns } from "./index.vue?vue&type=template&id=db122144&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db122144",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('db122144')) {
      api.createRecord('db122144', component.options)
    } else {
      api.reload('db122144', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=db122144&scoped=true", function () {
      api.rerender('db122144', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mealOrder/mealView/mealBrand/index.vue"
export default component.exports